<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form  :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <div class="line-box">
      <el-form-item class="hundred" label="落地页" prop="pageId" >
              <el-select class="hundred" v-model="dataForm.pageId" filterable clearable placeholder="请选择落地页">
                  <el-option
                          v-for="item in pages"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
      </el-form-item>
     
      <!-- <el-form-item label="投放策略" prop="strategy">
              <el-select v-model="dataForm.strategy" filterable clearable placeholder="请选择投放策略">
              <el-option
                      v-for="item in strategys"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
              </el-option>
              </el-select>
      </el-form-item> -->
     
      <el-form-item class="hundred" label="城市" prop="city">
              <el-select class="hundred" v-model="dataForm.city" filterable clearable multiple placeholder="请选择城市" >
                  <el-option
                          v-for="item in citys"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
      </el-form-item>
<!--          <el-form-item label="状态（开1、关0）" prop="status">-->
<!--          <el-input v-model="dataForm.status" placeholder="状态（开1、关0）"></el-input>-->
<!--      </el-form-item>-->
</div>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
        citys:[],
        pages:[],
        strategys:[
            {
                'label':'轮询',
                'value':1,
            },
            {
                'label':'随机',
                'value':2,
            }
        ],
      dataForm: {
        id: '',
        pageId: '',
        city: '',
        strategy: '1',
        status: '',
        createBy: '',
        createTime: '',
        updateBy: '',
        updateTime: '',
        deleteTime: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        pageId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        city: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        strategy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
      //初始化下拉框中的选项
      async getCityOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=landing_page_city`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.citys=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.citys.push({label:element.dictLabel,value:element.dictValue})
                  })
                  /*let citys = {}
                  for(let i = 0; i< res.data.length; i++){
                      citys[i].value=res.data[i].dictValue
                      citys[i].label=res.data[i].dictLabel
                  }*/
              }
          }).catch(() => {})
      },
      //初始化落地页下拉框中的选项
      async getPageOptions() {
          this.$http.get(`/sys/landingpages/list`).then(({ data: res }) => {
              
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.pages=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.pages.push({label:element.name,value:element.id})
                  })
                  /*let citys = {}
                  for(let i = 0; i< res.data.length; i++){
                      citys[i].value=res.data[i].dictValue
                      citys[i].label=res.data[i].dictLabel
                  }*/
              }
          }).catch(() => {})
      },
    init () {
        this.getCityOptions();
        this.getPageOptions();
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/scopecity/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        res.data.city = res.data.city.split(',')
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
         console.log(this.dataForm)
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/scopecity/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
